// extracted by mini-css-extract-plugin
module.exports = {"HeaderCell":"ReportTable_HeaderCell__04m1g","FirstColumnHeader":"ReportTable_FirstColumnHeader__fyznH","NumericalHeader":"ReportTable_NumericalHeader__F0itl"};